import React, {FC} from 'react';
import Typography from '@mui/material/Typography';

import {BaseProps} from 'shared/types/base';
import {UserStatus, UserStatuses} from '../types';
import {Box, StatusBadge} from '@scope/scope-one-ui/core';
import {Status} from '@scope/scope-one-ui/core/StatusBadge/StatusBadge.d';


type UserStatusIndicatorProps = {
  status: UserStatus;
  showLabel?: boolean;
} & BaseProps;

const UserStatusIndicator: FC<UserStatusIndicatorProps> = ({status}) => {

  const statuses: Record<UserStatus, Status> = {
    [UserStatuses.INVITED]: 'INVITED',
    [UserStatuses.ACTIVE]: 'ACTIVE',
    [UserStatuses.DISABLED]: 'DISABLED',
    [UserStatuses.PENDING]: 'PENDING',
    [UserStatuses.BLOCKED]: 'DEACTIVATED',
    [UserStatuses.CONFIRMED] : 'AFFIRMED',
    [UserStatuses.UNCONFIRMED] : 'UNCONFIRMED',
  };

  return status ? (
    <Box display='flex' alignItems='center'>
      <StatusBadge status={statuses[status]}/>
    </Box>
  ) : (
    <Typography>-</Typography>
  );
};

export default UserStatusIndicator;
